import Model from './Model'

export default class Category extends Model {

    schema() {
        return {
            id: null,
            shop_id: null,
            name: null,
            slug: null,
            vehiculier: false,
            activated: false,
            created_at: null,
            updated_at: null,
            code_comarch: null,
            id_comarch: null,
            name_comarch: null,
            categories: []
        }
    }

}
